module.exports = __webpack_public_path__ + "primeicons.38d77552b0353684a208.svg";


//////////////////
// WEBPACK FOOTER
// /Users/trevor/src/src-westoaks3/west-oaks/node_modules/primeicons/fonts/primeicons.svg
// module id = ../../../../primeicons/fonts/primeicons.svg
// module chunks = styles